import React, { useState } from 'react';
import { soundManager } from '../utils/sound';
import '../styles/Modals.css';

interface AuthModalProps {
  onClose: () => void;
  onLoginSuccess: (user: { id: string; username: string; points: number }) => void;
}

const AuthModal: React.FC<AuthModalProps> = ({ onClose, onLoginSuccess }) => {
  const [isRegister, setIsRegister] = useState<boolean>(false);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');

    if (!username.trim() || !password.trim()) {
      setErrorMsg('请输入用户名和密码');
      return;
    }

    setLoading(true);
    soundManager.playClick();

    const endpoint = isRegister ? '/api/auth/register' : '/api/auth/login';

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password: password.trim() })
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || '请求失败');
      }

      if (data.token) {
        localStorage.setItem('zipai_token', data.token);
        localStorage.setItem('zipai_user', JSON.stringify(data.user));
      }

      soundManager.playCoinReward();
      onLoginSuccess(data.user);
      onClose();
    } catch (err: any) {
      // 离线/开发模式下的友好本地模拟兜底
      if (err.message.includes('Failed to fetch') || err.message.includes('404')) {
        const localUser = {
          id: `local_${Date.now()}`,
          username: username.trim(),
          points: parseInt(localStorage.getItem(`zipai_pts_${username}`) || '1000')
        };
        localStorage.setItem('zipai_user', JSON.stringify(localUser));
        onLoginSuccess(localUser);
        onClose();
        return;
      }
      setErrorMsg(err.message || '网络连接异常');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content auth-modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isRegister ? '📝 注册雀圣账号 (保留积分)' : '🔑 登录账号'}</h3>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form-body">
          <div className="auth-feature-banner">
            <span>✨ 注册即赠 <strong>1000</strong> 初始积分 · 云端永久保留战绩</span>
          </div>

          {errorMsg && <div className="auth-error-badge">{errorMsg}</div>}

          <div className="form-group">
            <label>玩家账号 / 昵称</label>
            <input
              type="text"
              placeholder="请输入用户名 (如: 湖南牌王)"
              value={username}
              onChange={e => setUsername(e.target.value)}
              maxLength={20}
              required
            />
          </div>

          <div className="form-group">
            <label>账号密码</label>
            <input
              type="password"
              placeholder="请输入密码 (至少6位)"
              value={password}
              onChange={e => setPassword(e.target.value)}
              minLength={6}
              required
            />
          </div>

          <button type="submit" className="btn-auth-submit" disabled={loading}>
            {loading ? '⏳ 处理中...' : isRegister ? '🎉 立即注册并领取1000积分' : '🚀 立即登录'}
          </button>

          <div className="auth-switch-row">
            {isRegister ? (
              <span>已有账号？ <button type="button" className="btn-link" onClick={() => setIsRegister(false)}>直接登录</button></span>
            ) : (
              <span>还没有账号？ <button type="button" className="btn-link" onClick={() => setIsRegister(true)}>免费注册</button></span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;
